/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const AncillaryType = {
    TravelInsurance: 'travel_insurance',
    BagInsurance: 'bag_insurance',
    CabinBag: 'cabin_bag',
    CheckedBag: 'checked_bag',
    Seat: 'seat',
    Lounge: 'lounge',
    Meal: 'meal',
    FastTrack: 'fast_track',
    Pet: 'pet',
    Change: 'change',
    Bundle: 'bundle',
    PaymentFee: 'payment_fee',
    Other: 'other'
};
export function AncillaryTypeFromJSON(json) {
    return AncillaryTypeFromJSONTyped(json, false);
}
export function AncillaryTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AncillaryTypeToJSON(value) {
    return value;
}
